import Vue from 'vue'
import Vuex from 'vuex'
import education from './education'
import {isMobWidth} from "../utils";
import router from "../router";

Vue.use(Vuex)

const modal_confirm = {title:'', desc:'', cancel_emit: '', ok_emit: '', open: false, ok_txt:'Да', cancel_txt: 'Нет', data: {}}
const common_info_modal = {title:'', desc:'', open: false}

export default new Vuex.Store({
    state: {
        burgerExpanded: true,
        isDarkTheme: false,
        modal_confirm,
        common_info_modal,
        favorites: null,
        current_project: null,
        router: {from: null, to: null},
        isMobWidth: isMobWidth(),
        users: null,
        coworkers: null,
        tags: null,
        projects: null,
        projects_by_user: null,
        projects_index: null,
        projects_index_archive: null,
        archive_projects_by_user: null,
        statuses: null,
        apps: null,
        vacancies: [],
        questionnaires: null,
        voice_messages: null,
        autoCollections: null,
        languages: null,
        tests: null,
        messageTemplates: null,
        section: 'hunt',
        subsection: '',
        chatNewCount: 0,
        user: null
    },
    mutations: {
        handleBurger(state) {
            localStorage.setItem('burger_expanded', !state.burgerExpanded ? 'true' : 'false')
            state.burgerExpanded = !state.burgerExpanded
        },
        setFunction(state, {payload, name}) {
            state[name] = payload;
        },
        setMobWidth(state) {
            state.isMobWidth = isMobWidth();
        },
        setIndexAllProjects(state, payload) {
            if(!Array.isArray(payload)) return
            state.projects_index = payload.filter(p => p.vacancies.length ? (p.vacancies.some(v => v.is_archive === null) || p.is_archive === null) : p.is_archive === null)
            state.projects_index_archive = payload.filter(p => p.vacancies.length ? (p.vacancies.some(v => v.is_archive === 1) || p.is_archive === 1) : p.is_archive === 1)
        },
        setProjects(state, payload) {
            if(!Array.isArray(payload)) return
            state.projects = payload
        },
        setArchiveProjects(state, payload) {
            if(!Array.isArray(payload)) return
            state.archive_projects = payload
        },
        openModalConfirm(state, payload = {}) {
            state.modal_confirm = {...modal_confirm, ...payload}
        },
        closeModalConfirm(state) {
            state.modal_confirm = {...modal_confirm}
        },
        openCommonInfoModal(state, payload = {}) {
            state.common_info_modal = {...common_info_modal, ...payload}
        },
        closeOpenInfoModal(state) {
            state.common_info_modal = {...common_info_modal}
        },
        setSection(state,section)
        {
            state.section = section;
        },
        setSubSection(state,section)
        {
            state.subsection = section;
        },
        setUserInfo(state,info)
        {
            state.user = info;
        },
        updateUserInfo(state,info)
        {
            state.user = {...state.user, ...info};
        },
        updateUserBalance(state,update)
        {
            if(state.user !== null && state.user.id) state.user.balance += Number(update);
        },
        updateUser(state, update) {
            state.user = {...state.user, ...update}
        },
        setLanguages(state, tests = []) {
            let lang_ids = [];
            let languages = [];
            tests.forEach(function(test) {
                test.languages.forEach(function(lang) {
                    if(lang_ids.indexOf(lang.id) === -1) {
                        lang_ids.push(lang.id);
                        languages.push({'title':lang.title,'id':lang.id});
                    }
                });
            });
            state.languages = languages;
        },
        removeFromFavorite(state, id = 0) {
            state.favorites = state.favorites.filter(f => f.id !== id)
        },
        addInFavorite(state, item) {
            state.favorites = [...state.favorites, item]
        }
    },
    getters: {
        getUser: (state) => state.user,
        getTemplate: (state) =>  type => state.messageTemplates?.find(t => t.type === type) || null,
        getUserIsDirector: (state, g) => !g.getUser?.is_customer && !g.getUser?.is_child,
        getUserId: (state, g) => g.getUser?.id || 0,
        getUserIsCustomer: (state, g) => g.getUser?.is_customer,
        getIsChild: (state, g) => g.getUser?.is_child,
        getUserAppsHH: (state) => state.user?.apps_info?.hh || null,
        getUserMap: state => state.users !== null ? state.users.reduce((acc, u) => {acc[u.id] = u; return acc}, {}) : {},
        getUserOptions: (state) => [{title: 'Не выбран', id: null}, ...state.users?.map(
            ({id, first_name, last_name}) => ({title: first_name + ' ' + last_name, id})
        ) || []],
        get: state => (name) => state[name] === null ? [] : state[name],
        activeSubscribe: state => state.user?.active_subscribe || null,
        inFavorite: state => (id, type) => state.favorites.find(f => f.type === type && f.item_id === id),
        overUser: (state, g) => g.getUser?.over_user || {},
        companyLogo: (state, g) => g.getUser?.over_user?.logo || g.getUser?.logo || null,
        filterApps: ({apps}) => type => {
            if(apps !== null) {
                return apps.filter((app) => {
                    if(type === 'onlyEmail') return ['gmail', 'yamail', 'email', 'custom-smtp'].includes(app.system)
                    else if(type === 'onlyCalendars') return ['yacalendar', 'googlecalendar'].includes(app.system)
                    else if(Array.isArray(type)) return !type.includes(app.system);
                    return app.system === type;
                })
            }
            return [];
        }
    },
    actions: {
        getMe({commit}) {
            window.http.get('/api/users/me')
                .then(response => {
                    commit('setUserInfo', response.data);
                    const lastLoginTs = localStorage.getItem('last_login')
                    const {path} = router.history.current;
                    if(response.data?.id && ['/login', '/registration', '/forgot-password'].some(p => path.match(new RegExp(p, 'i')))) {
                        router.replace('/')
                    }
                    if(lastLoginTs && ((Date.now() - Number(lastLoginTs)) < (2 * 10000))) {
                        commit('openCommonInfoModal');
                    }
                })
        },
        getFavorites({commit}, params = {}) {
            return window.http.get('/api/favorites', {params}).then(response => {
                commit('setFunction', {payload: response.data, name: 'favorites'})
            });

        },
        async removeFavorite({commit}, id = 0) {
            await window.http.delete('/api/favorites/' + id)
            commit('removeFromFavorite', id)
        },
        async addFavorite({commit}, payload) {
            const {data} = await window.http.post('/api/favorites', payload)
            console.log('resp', data)
            commit('addInFavorite', data)
        },
        getUsers({commit}, params = {}) {
            return window.http.get('/api/users/chain', {params}).then(response => {
                commit('setFunction', {payload: response.data, name: 'users'})
            });
        },
        getCoworkers({commit}, params = {}) {
            return window.http.get('/api/coworkers', {params}).then(response => {
                commit('setFunction', {payload: response.data, name: 'coworkers'})
            });
        },
        getIndexAllProjects({commit}, params = {}) {
            return window.http.get('/api/projects/index', {params: {with_archive: true, ...params}}).then(response => {
                commit('setIndexAllProjects', response.data)
            });
        },
        getProjects({commit}, params = {}) {
            return window.http.get('/api/projects/index', {params: {...params}}).then(response => {
                commit('setProjects', response.data)
            });
        },
        getArchiveProjects({commit}, params = {}) {
            return window.http.get('/api/projects/index', {params: {with_archive: 'only_archive', ...params}}).then(response => {
                commit('setArchiveProjects', response.data)
            });
        },
        getStatuses({commit}, params = {}) {
            return window.http.get('/api/statuses/get', {params}).then(response => {
                commit('setFunction', {payload: response.data, name: 'statuses'})
            });
        },
        getQuestionnaires({commit}, params = {}) {
            return window.http.get('/api/questionnaires/get', {params}).then(response => {
                commit('setFunction', {payload: response.data, name: 'questionnaires'})
            });
        },
        getApps({commit}, params = {}) {
            commit('setFunction', {payload: true, name: 'apps_loading'})
            return window.http.get('/api/apps/get', {params}).then(response => {
                commit('setFunction', {payload: response.data, name: 'apps'})
            });
        },
        getMessageTemplates({commit}, params = {}) {
            return window.http.get('/api/messages/get').then(({data}) => {
                commit('setFunction', {payload: data, name: 'messageTemplates'})
            })
        },
        getVacancies({commit}, params = {}) {
            return window.http.get('/api/vacancies', {params}).then(response => {
                commit('setFunction', {payload: response.data, name: 'vacancies'})
            });
        },
        getTags({commit}, params = {}) {
            return window.http.get('/api/tags', {params}).then(response => {
                commit('setFunction', {payload: response.data, name: 'tags'})
            });
        },
        getTests({commit}, params = {}) {
            return window.http.get('/api/tests/get', {params}).then(response => {
                commit('setFunction', {payload: response.data, name: 'tests'})
                commit('setLanguages', response.data)
            });
        },
        getAutoCollection({commit}, params = {}) {
            return window.http.get('/api/auto-collections/get', {params}).then(response => {
                commit('setFunction', {payload: response.data, name: 'autoCollections'})
            });
        },
        checkChatOnNew({commit}) {
            return window.http.get('/api/chat/is-read').then(response => {
                commit('setFunction', {payload: response.data, name: 'chatNewCount'})
            });
        },
        getVoiceMessages({commit}) {
            return window.http.get('/api/voice-messages/get').then(response => {
                commit('setFunction', {payload: response.data, name: 'voice_messages'})
            });
        }
    },
    modules: {
        education
    },
})
